<template>
  <div class="success-dialog">
    <el-dialog
      v-if="show"
      :title="title"
      :show-close="false"
      :visible.sync="show"
      width="432px"
      custom-class="dialog-cls"
      top="20%"
    >
      <p class="desc">
        {{ desc }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn-cls" @click="closeHander">{{ btnText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: 'I got it',
    },
  },
  methods: {
    closeHander() {
      // 通知父级更新弹出层显示状态
      this.$emit('update:show', false);
    },
  },
}
</script>
<style lang="scss">
  .success-dialog {
    .dialog-cls {
      border-radius: 16px;

      .el-dialog__header {
        margin-bottom: 20px;
        padding-top: 50px;
        text-align: center;
        font-weight: 600;
        color: var(--txt-color-lv1);
        font-size: 20px;
      }

      .el-dialog__body {
        padding: 0;
        margin-bottom: 44px;
        text-align: center;
        font-size: 16px;
        color: var(--txt-color-lv2);
        font-weight: 500;
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }

    .btn-cls {
      width: 240px;
      height: 48px;
      font-size: 20px;
      font-weight: 600;
      background: var(--txt-color-link);
      border-radius: 30px;
      border: none;
    }

    .desc {
      padding: 0 16px;
    }
  }
</style>
